import React from "react";
import styles from "./NavigationItem.module.css";

const navigationItem = (props) => {
	const clicked = () => {
		const el = document.getElementById(props.link);
		if (el) el.scrollIntoView(true);
		props.clicked();
	};

	return (
		<li className={styles.NavigationItem}>
			<div
				onClick={clicked}
				className={props.current ? styles.active : styles.inactive}
			>
				<div className={styles.label}>{props.children}</div>
				<span className={styles.span}></span>
			</div>
		</li>
	);
};

export default navigationItem;
